<app-modal>
  <h5 modal-title>Mijn abonnement op Assist</h5>
  <div modal-body class="pt-3" *ngIf="isLoading">
    <div class="text-center">
      <i class="fas fa-spinner-third fa-spin fa-3x"></i>
    </div>
  </div>
  <div modal-body class="pt-3" *ngIf="step == 1 && plusOrder">
    <!-- FREE -->
    <p *ngIf="currentSubscription?.SubscriptionTypeId === 5">
      Momenteel gebruik je <strong>Assist FREE</strong>, de gratis versie van Assist.<br />
      Upgrade naar Assist START of PLUS om alle functionaliteiten te ontgrendelen.<br />
      <a
        href="https://docs.google.com/document/d/1IWPYXL4Uum_mYSD1B3JcCm7ORiftxeWybUgvbywT4ec/edit?usp=sharing"
        target="_blank"
        class="text-decoration-underline"
        >Klik hier</a
      >
      om alle mogelijkheden van Assist te vergelijken.
    </p>

    <!-- PRF - NOG NIET VERLOPEN - GEEN FEDERATIE -->
    <p
      *ngIf="
        currentSubscription?.IsActive &&
        currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF'
      "
    >
      Je proefabonnement op Assist
      <strong>verloopt op {{ currentSubscription.EndDate | date: "dd/MM/yyyy" }}</strong
      >. Als je voor deze vervaldatum je abonnement verlengt, krijg je 20% korting op je eerste
      jaarabonnement.
    </p>

    <!-- PRF - VERLOPEN - GEEN FEDERATIE -->
    <p
      *ngIf="
        !currentSubscription?.IsActive &&
        currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF'
      "
    >
      Je proefabonnement op Assist is verlopen. Je kan je abonnement heractiveren en meteen verder
      werken waar je destijds gestopt bent.
    </p>

    <!-- AA/BNO - GEEN FEDERATIE -->
    <p
      *ngIf="
        !currentSubscription?.IsActive &&
        currentSubscription?.SubscriptionStatus?.Abbreviation === 'AA/BNO'
      "
    >
      Je abonnement op Assist is verlopen. Je kan je abonnement heractiveren en meteen verder werken
      waar je destijds gestopt bent.
    </p>

    <!-- ANA - GEEN FEDERATIE -->
    <p
      *ngIf="
        !currentSubscription?.IsActive &&
        currentSubscription?.SubscriptionStatus?.Abbreviation === 'ANA'
      "
    >
      Je abonnement op Assist is niet actief. Je kan je abonnement heractiveren en meteen verder
      werken waar je destijds gestopt bent.
    </p>

    <!-- ACTIEF ABONNEMENT - BIJNA VERLOPEN -->
    <p
      *ngIf="
        currentSubscription?.CanRenew &&
        currentSubscription?.SubscriptionStatus?.Abbreviation !== 'PRF' &&
        currentSubscription?.SubscriptionTypeId !== 5
      "
    >
      Je abonnement op Assist
      <strong>
        verloopt op
        {{ currentSubscription.EndDate | date: "dd/MM/yyyy" }} </strong
      >. Je kan nu al verlengen om zonder onderbreking te blijven werken.
    </p>

    <table class="table table-striped mb-0">
      <thead>
        <tr>
          <th scope="col" class="fs-4"></th>
          <th *ngIf="startOrder" scope="col" class="fs-4 text-lg-end">Assist START</th>
          <th scope="col" class="fs-4 text-lg-end">Assist PLUS</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Status</td>
          <td *ngIf="startOrder" class="ps-2 text-lg-end">
            <span
              *ngIf="
                federation?.FreeStartSubscription &&
                !(
                  currentSubscription?.IsActive &&
                  currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF'
                )
              "
              >Gratis abonnement</span
            >
            <span
              *ngIf="
                !federation?.FreeStartSubscription &&
                currentSubscription?.SubscriptionTypeId === 4 &&
                currentSubscription?.IsActive &&
                !(
                  currentSubscription?.IsActive &&
                  currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF'
                )
              "
              >Actief abonnement</span
            >
            <span
              *ngIf="
                !federation?.FreeStartSubscription &&
                (currentSubscription?.SubscriptionTypeId !== 4 || !currentSubscription?.IsActive) &&
                !(currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF')
              "
              >Niet actief</span
            >
            <span
              *ngIf="
                currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF' &&
                federation?.FreeStartSubscription
              "
              >Gratis abonnement</span
            >
            <span
              *ngIf="
                currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF' &&
                !federation?.FreeStartSubscription
              "
              >Gratis proefabonnement</span
            >
            <span
              *ngIf="
                !federation?.FreeStartSubscription &&
                !currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF'
              "
              >Niet actief</span
            >
          </td>
          <td class="ps-2 text-lg-end">
            <span
              *ngIf="
                currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation === 'PRF'
              "
              >Gratis proefabonnement</span
            >
            <span
              *ngIf="
                currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation !== 'PRF' &&
                currentSubscription?.SubscriptionTypeId === 1
              "
              >Abonnement actief</span
            >
            <span
              *ngIf="
                currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation !== 'PRF' &&
                currentSubscription?.SubscriptionTypeId !== 1
              "
              >Niet actief</span
            >
            <span
              *ngIf="
                !currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation == 'PRF'
              "
              >Proefabonnement verlopen</span
            >
            <span
              *ngIf="
                !currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation == 'AA/BNO'
              "
              >Abonnement verlopen</span
            >
            <span
              *ngIf="
                !currentSubscription?.IsActive &&
                currentSubscription?.SubscriptionStatus?.Abbreviation == 'ANA'
              "
              >Abonnement niet actief</span
            >
          </td>
        </tr>
        <tr>
          <td>Startdatum</td>
          <td *ngIf="startOrder" class="ps-2 text-lg-end">
            {{ currentSubscription.RenewStartDate | date: "dd/MM/yyyy" }}
          </td>
          <td class="ps-2 text-lg-end">
            <span
              *ngIf="
                (!currentSubscription.IsActive || currentSubscription.SubscriptionTypeId === 4) &&
                currentSubscription.SubscriptionStatus.Abbreviation !== 'AA/BNO'
              "
            >
              {{ today | date: "dd/MM/yyyy" }}
            </span>
            <span
              [hidden]="
                (!currentSubscription.IsActive || currentSubscription.SubscriptionTypeId === 4) &&
                currentSubscription.SubscriptionStatus.Abbreviation !== 'AA/BNO'
              "
            >
              {{ currentSubscription.RenewStartDate | date: "dd/MM/yyyy" }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Vervaldatum</td>
          <td *ngIf="startOrder" class="ps-2 text-lg-end">
            <span *ngIf="federation?.HideDate === true">/</span>
            <span *ngIf="!federation?.HideDate === true">
              {{ currentSubscription.RenewEndDate | date: "dd/MM/yyyy" }}
            </span>
          </td>
          <td class="ps-2 text-lg-end">
            <span
              *ngIf="
                (!currentSubscription.IsActive || currentSubscription.SubscriptionTypeId === 4) &&
                currentSubscription.SubscriptionStatus.Abbreviation !== 'AA/BNO'
              "
            >
              {{ nextYear | date: "dd/MM/yyyy" }}
            </span>
            <span
              *ngIf="
                (currentSubscription.IsActive && currentSubscription.SubscriptionTypeId !== 4) ||
                currentSubscription.SubscriptionStatus.Abbreviation === 'AA/BNO'
              "
              [hidden]="
                federation?.DefaultEndDateId === 4 &&
                currentSubscription.SubscriptionStatus.Abbreviation === 'PRF'
              "
            >
              {{ currentSubscription.RenewEndDate | date: "dd/MM/yyyy" }}
            </span>
            <span
              *ngIf="
                currentSubscription.IsActive &&
                currentSubscription.SubscriptionTypeId !== 4 &&
                federation?.DefaultEndDateId === 4 &&
                currentSubscription.SubscriptionStatus.Abbreviation === 'PRF'
              "
            >
              {{ currentSubscription.DowngradeDate | date: "dd/MM/yyyy" }}
            </span>
          </td>
        </tr>
        <tr *ngFor="let oi of plusOrder.OrderItems; index as i">
          <td class="ps-2">
            {{ oi.ProductName.indexOf("Jaarabonnement") > -1 ? "Standaard prijs" : oi.ProductName }}
          </td>
          <td class="ps-2 text-lg-end" *ngIf="startOrder">
            {{
              startOrder.OrderItems.length > i
                ? (startOrder.OrderItems[i].CalculatedTotalPrice | currency)
                : ""
            }}
          </td>
          <td class="ps-2 text-lg-end">
            {{ plusOrder.OrderItems[i].CalculatedTotalPrice | currency }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-bottom-0 font-weight-bold">
          <td class="ps-2">Totaal te betalen</td>
          <td *ngIf="startOrder" class="ps-2 text-lg-end">
            {{ startOrder.TotalPriceAndVAT | currency }}
          </td>
          <td class="ps-2 text-lg-end">
            {{ plusOrder.TotalPriceAndVAT | currency }}
          </td>
        </tr>
        <tr class="border-bottom-0">
          <td class="border-bottom-0 ps-2"></td>
          <td *ngIf="startOrder" class="border-bottom-0 ps-2 text-lg-end">
            @if (currentSubscription.CanRenew) {
              <button
                type="button"
                class="btn btn-success btn-block mt-2"
                (click)="next(startOrder)"
              >
                <span *ngIf="currentSubscription?.SubscriptionTypeId == 1"
                  >Downgrade naar Assist START</span
                >
                <span *ngIf="currentSubscription?.SubscriptionTypeId == 4"
                  >Assist START verlengen</span
                >
                <span *ngIf="currentSubscription?.SubscriptionTypeId == 5"
                  >Assist START activeren</span
                >
              </button>
            }
          </td>
          <td class="border-bottom-0 ps-2 text-lg-end">
            @if (
              currentSubscription.CanRenew ||
              currentSubscription?.SubscriptionTypeId == 5 ||
              currentSubscription?.SubscriptionTypeId == 4
            ) {
              <button
                type="button"
                class="btn btn-success btn-block mt-2"
                (click)="next(plusOrder)"
              >
                <span *ngIf="currentSubscription?.SubscriptionTypeId == 1"
                  >Assist PLUS verlengen</span
                >
                <span
                  *ngIf="
                    currentSubscription?.SubscriptionTypeId == 4 ||
                    currentSubscription?.SubscriptionTypeId == 5
                  "
                  >Upgrade naar Assist PLUS</span
                >
              </button>
            }
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div modal-body class="pt-3" *ngIf="step == 2">
    <h5>Facturatieadres</h5>
    <app-horizontal-wrapper [label]="'Naam'">
      <strong>{{ facturationAddress.Name.value || "-" }}</strong>
    </app-horizontal-wrapper>
    <app-horizontal-wrapper [label]="'Ondernemingsnummer'">
      <strong>{{ facturationAddress.VatNumber.value || "-" }}</strong>
    </app-horizontal-wrapper>
    <app-address-base-edit
      [form]="facturationAddress"
      [showSelect]="false"
      [fields]="['Name', 'StreetNrBus', 'Location', 'Country']"
      [showButtons]="false"
      [alignRight]="false"
    ></app-address-base-edit>
  </div>

  <div modal-body class="pt-3" *ngIf="step == 3 && payment">
    <div *ngIf="payment.Succeed" class="text-center">
      <div class="mb-4">
        <i class="fas fa-check-circle fa-4x text-success"></i>
      </div>
      <h4 class="text-success mb-3">Betaling succesvol afgerond!</h4>
      <p class="mb-3">
        Je betaling via {{ payment.Method }} van {{ payment.Amount | currency }} is succesvol
        verwerkt. Je abonnement op Assist is nu actief en je kan meteen aan de slag.
      </p>
      <p class="text-muted">
        Je ontvangt binnen enkele ogenblikken een bevestigingsmail en de factuur. <br />Bedankt voor
        je vertrouwen in Assist!
      </p>
    </div>

    <div *ngIf="payment.Canceled" class="text-center">
      <div class="mb-4">
        <i class="fas fa-times-circle fa-4x text-warning"></i>
      </div>
      <h4 class="text-warning mb-3">Betaling geannuleerd</h4>
      <p class="mb-3">
        Je hebt de betaling van {{ payment.Amount | currency }} via
        {{ payment.Method }} geannuleerd. Geen probleem, er zijn geen kosten in rekening gebracht.
      </p>
      <p class="text-muted">
        Wil je toch je abonnement activeren? Sluit dan dit venster en start het bestelproces
        opnieuw. Heb je vragen of ondervind je problemen? <br />Contacteer dan gerust Vincent via
        <a href="mailto:vincent@assistonline.eu">vincent&#64;assistonline.eu</a>.
      </p>
    </div>

    <div *ngIf="!payment.Succeed && !payment.Canceled" class="text-center">
      <div class="mb-4">
        <i class="fas fa-spinner fa-spin fa-4x text-primary"></i>
      </div>
      <h4 class="text-primary mb-3">Betaling wordt verwerkt...</h4>
      <p class="mb-3">
        We wachten momenteel op de bevestiging van je betaling via {{ payment.Method }} voor een
        bedrag van {{ payment.Amount | currency }}.
      </p>
      <p class="text-muted">
        Dit kan enkele ogenblikken duren, koos je voor overschrijving zelfs enkele dagen. De
        betaling wordt verwerkt door onze betalingspartner en zodra we de bevestiging ontvangen,
        activeren we automatisch je abonnement. Je hoeft deze pagina niet open te houden - je
        ontvangt een bevestigingsmail zodra alles in orde is.
      </p>
    </div>
  </div>
  <div modal-footer class="right">
    <app-button
      *ngIf="step == 2"
      (click)="payRenewal(orderToRenew)"
      [iconEndClass]="'fa-arrow-right'"
      [buttonClass]="'btn btn-success btn-block mt-2 float-right'"
      [isSaving]="isLoading"
    >
      Bestel nu
      {{
        (orderToRenew?.OrderItems?.[0]?.ProductName ?? "Verlengen").replace("Jaarabonnement", "")
      }}
      voor {{ orderToRenew?.TotalPriceAndVAT | currency }}
    </app-button>
  </div>
</app-modal>
